@if(loading){<lib-spinner-dialog></lib-spinner-dialog>}

<lib-dba-mat-table tableNameId="ee626e6f-f1cc-4426-a8a0-e592cebe8767" [data]="uuidList" [columnsdef]="columnList"
    [editButton]="false" [importButton]="false" [exportButton]="false" [dynamicSize]="true"
    (createClicked)="CreateCodes()">

    <lib-dba-mat-table-button [title]="language.Export | translationPipe" (click)="export()"></lib-dba-mat-table-button>
</lib-dba-mat-table>